import React from "react";
import {
	Box,
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	IconButton,
	Typography
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import { useTranslation } from "react-i18next";
import { zoullooColors } from "../../../theme";
import StarRating from "./StarRating";
import HtmlEditor from "../../UI/HtmlEditor";

interface EvaluationEditDialogProps {
	open: boolean;
	rating: number;
	comment: string;
	isPending: boolean;
	onRatingChange: (value: number) => void;
	onCommentChange: (value: string) => void;
	onConfirm: () => void;
	onClose: () => void;
}

const EvaluationEditDialog: React.FC<EvaluationEditDialogProps> = ({
	open,
	rating,
	comment,
	isPending,
	onRatingChange,
	onCommentChange,
	onConfirm,
	onClose
}) => {
	const { t } = useTranslation();

	return (
		<Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
			<DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
				{t("evaluations.editEvaluation")}
				<IconButton onClick={onClose}>
					<CloseIcon />
				</IconButton>
			</DialogTitle>
			<DialogContent>
				<Box sx={{ mt: 1 }}>
					<Typography variant="subtitle2" sx={{ mb: 1 }}>
						{t("evaluations.form.rating")}
					</Typography>
					<StarRating
						value={rating}
						onChange={onRatingChange}
						size="large"
					/>
				</Box>

				<Box sx={{ mt: 2 }}>
					<Typography variant="subtitle2" sx={{ mb: 1 }}>
						{t("evaluations.form.comment")}
					</Typography>
					<HtmlEditor
						content={comment}
						onUpdate={({ editor }) => onCommentChange(editor.getHTML())}
					/>
				</Box>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose}>
					{t("common.cancel")}
				</Button>
				<Button
					variant="contained"
					onClick={onConfirm}
					disabled={isPending}
					sx={{
						backgroundColor: zoullooColors.secondary.main,
						"&:hover": { backgroundColor: zoullooColors.secondary.dark }
					}}
				>
					{t("common.save")}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default EvaluationEditDialog;
